var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CustomColumnType, } from '../../../../../common/api';
import { parseInterval } from '../../util/helpers';
import { getTagLongName, getTimeDimensionName } from '../tag/tagUtil';
import { isDimensionTag, isGroupTag, isTableTag } from '../tag/types';
import { TagNameDisplay } from '../types';
export var NEW_SHEET_ROW = {
    name: 'Row',
    parentId: null,
    accountTagId: null,
    tableTagId: null,
    predicate: null,
    customColumns: [],
    dimensionTagIds: [],
    readonly: false,
    withData: false,
    hierarchyFlatten: false,
    hierarchyMaxDepth: 0,
};
var SheetRowPath = /** @class */ (function () {
    function SheetRowPath(path) {
        this.path = path;
        this.segments = [];
        var pathSegments = path.split('_');
        this.sheetRowId = Number(pathSegments[pathSegments.length - 1].split(':')[0]);
        var fullPath = '';
        for (var i = 0; i < pathSegments.length; i++) {
            var pathSegment = pathSegments[i];
            var tagId = void 0;
            var sheetRowId = 0;
            if (fullPath !== '') {
                fullPath += '_';
            }
            fullPath += pathSegment;
            // check if cluster is generated
            if (pathSegment.indexOf(':') !== -1) {
                var pathSegmentSplat = pathSegment.split(':');
                sheetRowId = Number(pathSegmentSplat[0]);
                tagId = Number(pathSegmentSplat[1]);
            }
            else {
                sheetRowId = Number(pathSegment);
            }
            this.segments.push({
                sheetRowId: sheetRowId,
                tagId: tagId,
                fullPath: fullPath,
                pathSegment: pathSegment,
            });
        }
    }
    SheetRowPath.prototype.includes = function (path) {
        var e_1, _a;
        try {
            for (var _b = __values(this.segments), _c = _b.next(); !_c.done; _c = _b.next()) {
                var seg = _c.value;
                if (typeof path === 'string' ? seg.fullPath === path : seg.fullPath === path.path) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    SheetRowPath.prototype.toString = function () {
        return this.path;
    };
    SheetRowPath.prototype.getPath = function () {
        return this.segments.map(function (s) { return s.pathSegment; });
    };
    return SheetRowPath;
}());
export { SheetRowPath };
export function createSheetRowExpression(sheetRow, filterTagIds, options) {
    var year = options === null || options === void 0 ? void 0 : options.year;
    var version = options === null || options === void 0 ? void 0 : options.version;
    var allTags = sheetRow.allTags.map(function (t) { return t.id; }).join(',');
    var dimensions = sheetRow.dimensions.map(function (t) { return t.id; }).join(',');
    var versionAndYearIds = [];
    var filter = filterTagIds.length > 0 ? ',' + filterTagIds.join(',') : '';
    allTags += filter;
    dimensions += filter;
    if (version) {
        versionAndYearIds.push(version.versionTagId);
    }
    if (year) {
        versionAndYearIds.push(year.id);
    }
    var versionAndYear = versionAndYearIds.join(',');
    var versionAndYearWithComma = versionAndYear.length > 0 ? ',' + versionAndYear : '';
    return allTags.length > 0 ? "tags(".concat(allTags).concat(versionAndYearWithComma, ")") : "tags(".concat(versionAndYear, ")");
}
export function getSheetRowVariableAndDimensions(sheetRowElement, tagMap, generatedTag) {
    var e_2, _a, e_3, _b;
    var _c;
    var dimensions = [];
    var variable;
    var visitedDimensionIds = new Set();
    try {
        for (var _d = __values(sheetRowElement.inheritedDimensionTags), _e = _d.next(); !_e.done; _e = _d.next()) {
            var tagInfo = _e.value;
            if (visitedDimensionIds.has(tagInfo.dimensionTagId)) {
                continue;
            }
            visitedDimensionIds.add(tagInfo.dimensionTagId);
            dimensions.push({
                id: tagInfo.dimensionTagId,
                inherited: true,
                originalClusterId: tagInfo.ancestorId,
                originalClusterTitle: tagInfo.ancestorName,
            });
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        for (var _f = __values(sheetRowElement.dimensionTagIds), _g = _f.next(); !_g.done; _g = _f.next()) {
            var id = _g.value;
            if (visitedDimensionIds.has(id)) {
                continue;
            }
            visitedDimensionIds.add(id);
            dimensions.push({
                id: id,
                inherited: false,
                originalClusterId: sheetRowElement.id,
                originalClusterTitle: sheetRowElement.name,
            });
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        }
        finally { if (e_3) throw e_3.error; }
    }
    if (generatedTag && !visitedDimensionIds.has(generatedTag.id)) {
        visitedDimensionIds.add(generatedTag.id);
        dimensions.push({
            id: generatedTag.id,
            originalClusterId: sheetRowElement.id,
            inherited: true,
            originalClusterTitle: sheetRowElement.name,
        });
    }
    var accountTag = tagMap[(_c = sheetRowElement.accountTagId) !== null && _c !== void 0 ? _c : 0];
    var inheritedAccountTag = sheetRowElement.inheritedAccountTags[sheetRowElement.inheritedAccountTags.length - 1];
    if (accountTag) {
        variable = {
            id: accountTag.id,
            inherited: false,
            originalClusterId: sheetRowElement.id,
            originalClusterTitle: sheetRowElement.name,
        };
    }
    if (inheritedAccountTag && !accountTag) {
        variable = {
            id: inheritedAccountTag.accountTagId,
            inherited: true,
            originalClusterId: sheetRowElement.id,
            originalClusterTitle: sheetRowElement.name,
        };
    }
    return { dimensions: dimensions, variable: variable, allTags: variable ? __spreadArray([variable], __read(dimensions), false) : dimensions };
}
export function createExtendedSheetRow(sheetRowPath, sheetRowElement, sheetRow, tagMap, depth, expanded) {
    var _a, _b;
    if (depth === void 0) { depth = 0; }
    if (expanded === void 0) { expanded = false; }
    var targetSegment = sheetRowPath.segments[sheetRowPath.segments.length - 1];
    var generatedTagId = targetSegment.tagId;
    var generatedTag = tagMap[generatedTagId !== null && generatedTagId !== void 0 ? generatedTagId : 0];
    var accountTag = tagMap[(_a = sheetRow.accountTagId) !== null && _a !== void 0 ? _a : 0];
    var _c = getSheetRowVariableAndDimensions(sheetRowElement, tagMap, generatedTag), allTags = _c.allTags, dimensions = _c.dimensions, variable = _c.variable;
    var tagDescription = (_b = generatedTag === null || generatedTag === void 0 ? void 0 : generatedTag.description) !== null && _b !== void 0 ? _b : accountTag === null || accountTag === void 0 ? void 0 : accountTag.description;
    return {
        id: sheetRowElement.id,
        name: sheetRowElement.name,
        allTags: allTags,
        dimensions: dimensions,
        variable: variable,
        order: sheetRow.order,
        parentTagId: sheetRowElement.tableTagId,
        generatedTagId: generatedTagId,
        generatedTag: generatedTag,
        path: sheetRowPath.toString(),
        sheetRow: sheetRow,
        hasChildren: sheetRowElement.hasChildren,
        customColumns: sheetRowElement.customColumns,
        depth: depth,
        expanded: expanded,
        tagDescription: tagDescription !== null && tagDescription !== void 0 ? tagDescription : '',
    };
}
export function createSheetRowName(row, options) {
    var _a;
    var display = (_a = options === null || options === void 0 ? void 0 : options.display) !== null && _a !== void 0 ? _a : TagNameDisplay.Both;
    var year = options === null || options === void 0 ? void 0 : options.year;
    var version = options === null || options === void 0 ? void 0 : options.version;
    var versionSuffix = version ? " (".concat(version.name, ")") : '';
    var yearSuffix = year ? " (".concat(getTimeDimensionName(year), ")") : '';
    if (row.generatedTag) {
        var tagName = getTagLongName(row.generatedTag, display);
        return "".concat(tagName).concat(yearSuffix).concat(versionSuffix);
    }
    return row.name + yearSuffix + versionSuffix;
}
export function getSheetRowParents(sheetRow, sheetRowMap) {
    var _a;
    var getParents = function (sheetRow, parents) {
        if (parents === void 0) { parents = []; }
        var parent = sheetRow.parentId ? sheetRowMap[sheetRow.parentId] : null;
        if (parent === undefined) {
            return parents;
        }
        if (parent === null) {
            return __spreadArray(__spreadArray([], __read(parents), false), [parent], false);
        }
        parents.push(parent);
        return getParents(parent, parents);
    };
    var parents = (_a = getParents(sheetRow)) !== null && _a !== void 0 ? _a : [];
    return parents;
}
function createTagExpressionToken(tag, tagById) {
    var _a;
    var parentTag = tagById[(_a = tag === null || tag === void 0 ? void 0 : tag.ParentId) !== null && _a !== void 0 ? _a : 0];
    return parentTag ? "\"".concat(parentTag.name, "\">\"").concat(tag.name, "\"") : '"' + tag.name + '"';
}
function createVersionExpressions(shownVersions, tagById) {
    var e_4, _a;
    var versionExpressions = [];
    try {
        for (var shownVersions_1 = __values(shownVersions), shownVersions_1_1 = shownVersions_1.next(); !shownVersions_1_1.done; shownVersions_1_1 = shownVersions_1.next()) {
            var versionOrId = shownVersions_1_1.value;
            var versionTag = tagById[versionOrId.versionTagId];
            if (!versionTag) {
                continue;
            }
            var versionExpression = createTagExpressionToken(versionTag, tagById);
            versionExpressions.push(versionExpression);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (shownVersions_1_1 && !shownVersions_1_1.done && (_a = shownVersions_1.return)) _a.call(shownVersions_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return versionExpressions;
}
export function createDefaultSearchCompoundExpression(interval, activeYears, tagById, internalTagsMap, shownVersions) {
    var _a = parseInterval(interval.start, interval.end, activeYears), startMonth = _a.startMonth, startYear = _a.startYear, endMonth = _a.endMonth, endYear = _a.endYear;
    var yearsMonthsCombos = [];
    var _loop_1 = function (i) {
        var year = activeYears[i];
        if (year < startYear || year > endYear) {
            return "continue";
        }
        var yearTag = internalTagsMap.years.find(function (y) { return y.order === year; });
        if (!yearTag) {
            return "continue";
        }
        var yearExpression = createTagExpressionToken(yearTag, tagById);
        var yearMonthsCombo = [yearExpression, []];
        var _loop_2 = function (month) {
            if ((month < startMonth && year === startYear) || (month > endMonth && year === endYear)) {
                return "continue";
            }
            var monthTag = internalTagsMap.months.find(function (m) { return m.order === month; });
            if (!monthTag) {
                return "continue";
            }
            var monthExpression = createTagExpressionToken(monthTag, tagById);
            yearMonthsCombo[1].push(monthExpression);
        };
        for (var month = 1; month <= 12; month++) {
            _loop_2(month);
        }
        yearsMonthsCombos.push(yearMonthsCombo);
    };
    for (var i = 0; i < activeYears.length; i++) {
        _loop_1(i);
    }
    if (yearsMonthsCombos.length === 0) {
        return null;
    }
    var expressions = yearsMonthsCombos
        .map(function (c) { return "and(".concat(c[0], ",").concat(c[1].length > 1 ? "or(".concat(c[1].join(','), ")") : c[1][0], ")"); })
        .join(',');
    var yearsMonthsExpressions = yearsMonthsCombos.length > 1 ? "or(".concat(expressions, ")") : expressions;
    if (shownVersions.length === 0) {
        return yearsMonthsExpressions;
    }
    var versionExpressions = createVersionExpressions(shownVersions, tagById);
    return versionExpressions.length > 1
        ? "and(or(".concat(versionExpressions.join(','), "),").concat(yearsMonthsExpressions, ")")
        : "and(".concat(versionExpressions[0], ",").concat(yearsMonthsExpressions, ")");
}
export function createCustomDisplaySearchCompoundExpression(versionsByVersionId, versionsByYear, interval, activeYears, tagById, internalTagsMap) {
    var _a;
    var _b = parseInterval(interval.start, interval.end, activeYears), startMonth = _b.startMonth, startYear = _b.startYear, endMonth = _b.endMonth, endYear = _b.endYear;
    var yearsMonthsVersionsCombos = [];
    var _loop_3 = function (i) {
        var e_5, _c;
        var year = activeYears[i];
        if (year < startYear || year > endYear) {
            return "continue";
        }
        var yearTag = internalTagsMap.years.find(function (y) { return y.order === year; });
        if (!yearTag) {
            return "continue";
        }
        var versionIds = (_a = versionsByYear[year]) !== null && _a !== void 0 ? _a : [];
        var yearExpression = createTagExpressionToken(yearTag, tagById);
        var versions = [];
        try {
            for (var versionIds_1 = (e_5 = void 0, __values(versionIds)), versionIds_1_1 = versionIds_1.next(); !versionIds_1_1.done; versionIds_1_1 = versionIds_1.next()) {
                var id = versionIds_1_1.value;
                var version = versionsByVersionId[id];
                if (version) {
                    versions.push(version);
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (versionIds_1_1 && !versionIds_1_1.done && (_c = versionIds_1.return)) _c.call(versionIds_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        var versionExpressions = createVersionExpressions(versions !== null && versions !== void 0 ? versions : [], tagById);
        var yearMonthsVersionsCombo = [yearExpression, [], versionExpressions];
        var _loop_4 = function (month) {
            if ((month < startMonth && year === startYear) || (month > endMonth && year === endYear)) {
                return "continue";
            }
            var monthTag = internalTagsMap.months.find(function (m) { return m.order === month; });
            if (!monthTag) {
                return "continue";
            }
            var monthExpression = createTagExpressionToken(monthTag, tagById);
            yearMonthsVersionsCombo[1].push(monthExpression);
        };
        for (var month = 1; month <= 12; month++) {
            _loop_4(month);
        }
        yearsMonthsVersionsCombos.push(yearMonthsVersionsCombo);
    };
    for (var i = 0; i < activeYears.length; i++) {
        _loop_3(i);
    }
    if (yearsMonthsVersionsCombos.length === 0) {
        return null;
    }
    var expression = yearsMonthsVersionsCombos
        .map(function (c) {
        return "and(".concat(c[0], ",").concat(c[1].length > 1 ? "or(".concat(c[1].join(','), ")") : c[1][0], ", ").concat(c[2].length > 1 ? "or(".concat(c[2].join(','), ")") : c[2][0], ")");
    })
        .join(',');
    return yearsMonthsVersionsCombos.length === 1 ? expression : "or(".concat(expression, ")");
}
export function getFilterCompoundExpression(filterTagIds, tagMap) {
    var e_6, _a;
    var _b, _c;
    if (filterTagIds.length === 0) {
        return null;
    }
    var expressions = [];
    try {
        for (var filterTagIds_1 = __values(filterTagIds), filterTagIds_1_1 = filterTagIds_1.next(); !filterTagIds_1_1.done; filterTagIds_1_1 = filterTagIds_1.next()) {
            var id = filterTagIds_1_1.value;
            var dimension = tagMap[id];
            if (!isDimensionTag(dimension)) {
                continue;
            }
            var parentNames = [];
            var parent = tagMap[(_b = dimension.ParentId) !== null && _b !== void 0 ? _b : 0];
            while (parent) {
                if (isGroupTag(parent) || isTableTag(parent)) {
                    parentNames.unshift("\"".concat(parent.name, "\""));
                }
                parent = tagMap[(_c = parent.ParentId) !== null && _c !== void 0 ? _c : 0];
            }
            var dimensionName = "\"".concat(dimension.name, "\"");
            expressions.push(parentNames.length > 0 ? "".concat(parentNames.join('>'), ">").concat(dimensionName) : dimensionName);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (filterTagIds_1_1 && !filterTagIds_1_1.done && (_a = filterTagIds_1.return)) _a.call(filterTagIds_1);
        }
        finally { if (e_6) throw e_6.error; }
    }
    return expressions.length > 0 ? "and(".concat(expressions.join(','), ")") : null;
}
export function getWithDataCompoundExpression(versionsByYear, interval, activeYears, tagById, internalTagsMap, shownVersions, activeVersions) {
    var versionsByVersionId = activeVersions.reduce(function (map, v) {
        map[v.id] = v;
        return map;
    }, {});
    var isCustomDataDisplay = Object.keys(versionsByYear).length;
    return isCustomDataDisplay
        ? createCustomDisplaySearchCompoundExpression(versionsByVersionId, versionsByYear, interval, activeYears, tagById, internalTagsMap)
        : createDefaultSearchCompoundExpression(interval, activeYears, tagById, internalTagsMap, shownVersions);
}
export function extractSheetRowDataFromPath(path, pathPosition) {
    var e_7, _a;
    if (pathPosition === void 0) { pathPosition = -1; }
    var pathSplat = path.split('_');
    if (pathSplat.length === 0) {
        return [-1, []];
    }
    var index = pathPosition;
    if (index < 0) {
        index = pathSplat.length + index;
    }
    var lastSegment = pathSplat[index];
    var sheetRowId = 0;
    var generatedTagIds = [];
    // check if the path segment is a generator tag
    if (lastSegment.includes(':')) {
        var splat = lastSegment.split(':');
        sheetRowId = Number(splat[0]);
        if (splat.length > 1) {
            var tags = splat[1];
            var tagsStr = tags.split(',');
            try {
                for (var tagsStr_1 = __values(tagsStr), tagsStr_1_1 = tagsStr_1.next(); !tagsStr_1_1.done; tagsStr_1_1 = tagsStr_1.next()) {
                    var tagStr = tagsStr_1_1.value;
                    var tagId = Number(tagStr);
                    if (!isNaN(tagId)) {
                        generatedTagIds.push(tagId);
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (tagsStr_1_1 && !tagsStr_1_1.done && (_a = tagsStr_1.return)) _a.call(tagsStr_1);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
    }
    else {
        sheetRowId = Number(lastSegment);
    }
    if (sheetRowId === 0 || isNaN(sheetRowId)) {
        return [null, []];
    }
    return [sheetRowId, generatedTagIds];
}
export function selectActionsBySheetRowId(data) {
    return data.reduce(function (map, document) {
        map[document.id] = document;
        return map;
    }, {});
}
export function getSearchNumberColumnsData(row) {
    var e_8, _a;
    var _b;
    if (!row) {
        return [];
    }
    var result = [];
    try {
        for (var _c = __values(row.customColumns), _d = _c.next(); !_d.done; _d = _c.next()) {
            var column = _d.value;
            if (column.type === CustomColumnType.Number &&
                column.accountTagId !== undefined &&
                column.dimensionTagIds !== undefined) {
                result.push({ accountTagId: (_b = column.accountTagId) !== null && _b !== void 0 ? _b : undefined, dimensionTagIds: column.dimensionTagIds });
            }
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_8) throw e_8.error; }
    }
    return result;
}
